import { render, staticRenderFns } from "./FormComplaint.vue?vue&type=template&id=59ad27fe&"
import script from "./FormComplaint.vue?vue&type=script&lang=js&"
export * from "./FormComplaint.vue?vue&type=script&lang=js&"
import style0 from "./FormComplaint.vue?vue&type=style&index=0&id=59ad27fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports